export const FIND_ROOFERS_ROUTE_PATTERN = /^\/find-(.*)-roofers$/;
export const ROOF_SCAN_ROUTE_PATTERN = /^\/(.*)-roof-scan$/;

/** Generic traffic LP paths (no state segment). */
export const TRAFFIC_GENERIC_ROUTES = [
  '/find-roofers',
  '/roof-scan',
  '/roof-quote',
] as const;

/** Paths that use the same LP experience as /roof-scan (banner, how-it-works copy, etc.). */
export function isRoofScanStylePath(path: string): boolean {
  return path === '/roof-scan' || path === '/roof-quote' || path.includes('roof-scan');
}

/** True when the questionnaire was started from a roof-scan style landing page CTA. */
export function isRoofScanEndpointCta(
  landingPagePath: string | null | undefined
): boolean {
  if (!landingPagePath?.trim()) {
    return false;
  }

  const path = landingPagePath.startsWith('/')
    ? landingPagePath
    : `/${landingPagePath}`;

  return isRoofScanStylePath(path);
}

/**
 * Converts URL state format (e.g., "new-jersey") to stateName format (e.g., "newjersey-v2")
 * @param urlState - State name from URL (e.g., "new-jersey")
 * @returns State name format used in constants (e.g., "newjersey-v2")
 */
export function convertUrlStateToStateName(urlState: string): string {
  // Remove hyphens and add "-v2" suffix
  return `${urlState.replace(/-/g, '')}-v2`;
}
